var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{class:[!_vm.footer ? 'hide' : '', _vm.navFooterScheme],attrs:{"fixed":_vm.fixedFooter,"inset":!_vm.fixedFooter,"app":""}},[_c('v-spacer'),_c('div',{staticClass:"pa-3"},[_vm._v("Powered by TaskTeacher")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }